export default __webpack_public_path__ + "static/Temp_ConsultationRoom-1bfbf0753ebe84331723e2c55f558f0b.webp";